var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.2449 48C94.2449 73.5403 73.5404 94.2448 48.0001 94.2448C22.4598 94.2448 1.75525 73.5403 1.75525 48C1.75525 22.4597 22.4598 1.75519 48.0001 1.75519C73.5404 1.75519 94.2449 22.4597 94.2449 48Z",
    stroke: "#EC1C2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5164 31.0513C69.6669 31.6297 71.3603 33.3342 71.9352 35.4985C72.9796 39.4216 72.9796 47.6065 72.9796 47.6065C72.9796 47.6065 72.9796 55.7912 71.9352 59.7147C71.3603 61.8786 69.6669 63.5831 67.5164 64.1617C63.6189 65.2128 47.9897 65.2128 47.9897 65.2128C47.9897 65.2128 32.3607 65.2128 28.4632 64.1617C26.3127 63.5831 24.6191 61.8788 24.0445 59.7145C23 55.7914 23 47.6065 23 47.6065C23 47.6065 23 39.4216 24.0445 35.4985C24.6191 33.3342 26.3127 31.6297 28.4632 31.0513C32.3607 30 47.9897 30 47.9897 30C47.9897 30 63.6189 30 67.5164 31.0513ZM55.9411 47.6067L42.8782 55.0376V40.1751L55.9411 47.6067Z",
    fill: "#EC1C2E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtubeIcon.a005b9976132b41c14647dbc660576d7.svg";
export { ForwardRef as ReactComponent };